import styled from '@emotion/styled';

export const MapContainer = styled.div`
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
